import Vue from 'vue'
import VueRouter from "vue-router"
import store from "../store/index"

Vue.use(VueRouter)

const routes = [

    {
        path: '/',
        name: 'Home',
        component: () =>
            import ("../views/Index")
    },
    {
        path: '/temp',
        name: 'News',
        component: () =>
            import ("../views/NewsList")
    },
    {
        path: '/zhuanti/:id',
        name: 'zhuanti',
        component: () =>
            import ("../views/ZhuanTi")
    },
    {
        path: '/newsDetail/:id',
        name: 'newsDetail',
        component: () =>
            import ("../views/NewsDetail")
    },
    {
        path: '/studyDetail/:id',
        name: 'studyDetail',
        component: () =>
            import ("../views/StudyDetail")
    },
    {
        // id该子级栏目id  cateID该父级栏目id
        path: '/notify/:id/:cateID/:index/:name',
        name: 'notifynews',
        component: () =>
            import ("../views/Notify")
    },
    {
        path: '/djzx',
        name: 'djzx',
        component: () =>
            import ("../views/DangJianZiXun")
    },
    {
        path: '/zzsh',
        name: 'zzsh',
        component: () =>
            import ("../views/ZuZhiShengHuo")
    },
    {
        path: '/activityDetail/:id',
        name: 'activityDetail',
        component: () =>
            import ("../views/ActivityDetail")
    },
    {
        path: '/MeetingShow',
        name: 'MeetingShow',
        redirect: "/MeetingShow/meeting/1",
        component: () =>
            import ("../views/MeetingShow"),
        children: [{
                path: "meeting/:type",
                name: "meetingclass",
                component: () =>
                    import ("../components/meetingShow/MeetingBox")
            },
            {
                path: "toupiao",
                name: "toupiao",
                component: () =>
                    import ("../components/meetingShow/TouPiao")
            },
            {
                path: "mzpy",
                name: "mzpy",
                component: () =>
                    import ("../components/meetingShow/MinZuPingYi")
            },
            {
                path: "zhiyuan",
                name: "zhiyuan",
                component: () =>
                    import ("../components/meetingShow/ZhiYuan")
            },
        ]
    },
    {
        path: '/MeetingDetail/:id',
        name: 'MeetingDetail',
        component: () =>
            import ("../views/MeetingDetail")
    },
    {
        path: '/RedSchool',
        name: 'RedSchool',
        component: () =>
            import ("../views/RedSchool")
    },
    {
        path: '/moreNewsList',
        name: 'moreNewsList',
        component: () =>
            import ("../views/MoreNewsList")
    },
    {
        path: '/Login',
        name: 'Login',
        component: () =>
            import ("../views/Login")
    },
    {
        path: '/server',
        name: 'server',
        component: () =>
            import ("../views/ServerRoom")
    },
    {
        path: '/map',
        name: 'map',
        component: () =>
            import ("../components/map/BaiDuMap")
    },
    {
        path: '/kaoshi/:id',
        name: 'kaoshi',
        component: () =>
            import ("../views/KaoShi")
    },
    {
        path: '/ZuzhiInfo/:id',
        name: 'zhibu',
        component: () =>
            import ("../views/ZuzhiInfo")
    },

    // 支部会议
    {
        path: "/DeptMoreNews/:id",
        name: "moreNewsListss",
        component: () =>
            import ("../views/DeptMoreNews")
    },
    {
        path: '/DeptMeeting',
        name: 'zhibuinfo',
        component: () =>
            import ("../views/DeptMeeting"),
        children: [{
                path: "meeting/:type/:id",
                name: "meetingclassed",
                component: () =>
                    import ("../components/zhibu/MeetingBox")
            },

            {
                path: "toupiao/:id",
                name: "toupiaodept",
                component: () =>
                    import ("../components/zhibu/TouPiao")
            },
            {
                path: "mzpy/:id",
                name: "mzpydept",
                component: () =>
                    import ("../components/zhibu/MinZuPingYi")
            },
            {
                path: "zhiyuan/:id",
                name: "zhiyuandept",
                component: () =>
                    import ("../components/zhibu/ZhiYuan")
            },
        ]
    },
    {
        path: '/MemberList/:id',
        name: 'MemberList',
        component: () =>
            import ("../views/MemberList")
    },
    {
        path: '/DeptPhoto/:id',
        name: 'DeptPhoto',
        component: () =>
            import ("../views/DeptPhoto")
    },
    {
        path: '/editUserInfo',
        name: 'editUserInfo',
        component: () =>
            import ("../views/EditUserInfo")
    },
    {
        path: '/user',
        name: 'user',
        redirect: "/user/notify",
        component: () =>
            import ("../views/UserCenter"),
        children: [{
                path: 'notify',
                name: 'notifys',
                component: () =>
                    import ("../components/user/NotifyList"),
            },
            {
                path: 'myjifen',
                name: 'myjifen',
                component: () =>
                    import ("../components/user/MyJiFen"),
            },
            {
                path: 'jifenbang',
                name: 'jifenbang',
                component: () =>
                    import ("../components/user/JiFenBang"),
            },
            {
                path: 'dangfei',
                name: 'dangfei',
                component: () =>
                    import ("../components/user/DangFei"),
            },
            {
                path: 'shujixinxiang',
                name: 'shujixinxiang',
                component: () =>
                    import ("../components/user/ShuJiXinXiang"),
            },
            {
                path: 'mykaoshi',
                name: 'mykaoshi',
                component: () =>
                    import ("../components/user/MyKaoShi"),
            },
            {
                path: 'mystudy',
                name: 'mystudy',
                component: () =>
                    import ("../components/user/MyStudy"),
            },
            {
                path: 'myfav',
                name: 'myfav',
                component: () =>
                    import ("../components/user/MyFav"),
            },
            {
                path: 'StudyJiLu',
                name: 'StudyJiLu',
                component: () =>
                    import ("../components/user/StudyJiLu"),
            },
            {
                path: 'zhuanjie',
                name: 'zhuanjie',
                component: () =>
                    import ("../components/user/DeptZhuanJie"),
            },
            {
                path: 'yewu',
                name: 'yewu',
                component: () =>
                    import ("../components/user/WenZe"),
            },
            {
                path: 'fazhan',
                name: 'fazhan',
                component: () =>
                    import ("../components/user/FaZhan"),
            },
            {
                path: 'studybiji',
                name: 'studybiji',
                component: () =>
                    import ("../components/user/StudyBiJi"),
            },
        ]
    },



]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    },
})

// 解决重复跳转当前路径报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}


export default router